import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["option", "validateAction", "info"]

  connect() {
    this.optionTargets.forEach((item) => { item.hidden = true })
    this.validateActionTarget.hidden = true
    if (this.hasInfoTarget) { this.infoTarget.hidden = true }
  }

  showSelectedOption(event) {
    console.log("selected something")
    const optionValue = event.currentTarget.value

    this.optionTargets.forEach((item) => {
      console.log(item, (item.dataset.optionValue !== optionValue))
      item.hidden = (item.dataset.optionValue !== optionValue)
    })

    if (optionValue == "") {
      this.validateActionTarget.hidden = true
    } else {
      this.validateActionTarget.hidden = false
    }

    if (this.infoTarget && (optionValue == this.infoTarget.dataset.infoTrigger)) {
      this.infoTarget.hidden = false
    } else { this.infoTarget.hidden = true }
  }
}
